import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";

import CandidateHeaderComponent from "../Candidate/Components/CandidateHeaderComponent";
import RecruiterHeaderComponent from "../Recruiter/Components/RecruiterHeaderComponent";
import AdminHeaderComponent from "../Admin/Components/AdminHeaderComponent";

import { CandidateProfile } from "../Candidate/Types/CandidateType";
import { storage } from "../Shared/Utils/authStorage";
import { getCandidateById } from "../Candidate/Services/CandidateService";
import { getUserById } from "../App/Services/UserService";
import { UserForm } from "../App/Types/UsersType";

// ==========================================
// Shared Hook
// ==========================================
const useCandidateProfile = () => {
  const [candidate, setCandidate] = useState<UserForm | null>(null);

  useEffect(() => {
    const fetchCandidate = async () => {
      const userId = storage.getUserId();

      if (!userId) return;

      try {
        const response = await getUserById(userId);

        if (response.success) {
          setCandidate(response.data);
        }
      } catch (error) {
        console.error("Failed to load profile:", error);
      }
    };

    fetchCandidate();
  }, []);

  return candidate;
};

// ==========================================
// Candidate Layout
// ==========================================
export const CandidateLayout = () => {
  const candidate = useCandidateProfile();

  return (
    <div>
      <CandidateHeaderComponent candidate={candidate} />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

// ==========================================
// Recruiter Layout
// ==========================================
export const RecruitmentLayout = () => {
  const candidate = useCandidateProfile();

  return (
    <div>
      <RecruiterHeaderComponent candidate={candidate} />
      <main>
        <Outlet />
      </main>
    </div>

  );
};

// ==========================================
// Admin Layout
// ==========================================
export const AdminLayout = () => {
  const candidate = useCandidateProfile();

  return (
    <div>
      <AdminHeaderComponent candidate={candidate} />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

// ==========================================
// Data Service Layout
// Shared by SUPER_ADMIN and DELEGATED_ADMIN.
// The header itself hides the admin-only menu entries for a delegate.
// ==========================================
export const DataServiceLayout = () => {
  const candidate = useCandidateProfile();

  return (
    <div>
      <AdminHeaderComponent candidate={candidate} />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

// ==========================================
// Master Layout Container
// ==========================================
export const MasterLayoutContainer = ({
  children,
}: {
  children: () => React.ReactNode;
}) => {
  return <>{children()}</>;
};